




































































	import BaseTlTable from "./BaseTLTable.vue";
	import { Vue, Component, Prop, ObjectTypesHelper } from "../../Infrastructure/CorBase/CoreBase";

				@Component
				export default class BaseTLModalDialogTable extends Vue { 
                    @Prop({ type: Boolean, required: false, default: false }) onlyInfo?: boolean; //pouze informacni nevybiraci modal

                    @Prop({ type: Boolean, required: false, default: true }) allowDoubleClick?: boolean; //povoli doubleclick
					@Prop({ required: true }) itemsData: any; //zakladni datova napln
					@Prop({ required: true }) fields: any;  //jmena sloupců
					@Prop({ required: false }) filters: any;  //filter - seznam filtru a jejich typů
					@Prop({ type: String, required: true, default: "" }) name!: string; //nazev
                    @Prop({ type: String, required: false, default: "" }) name2?: string; //nazev druhy
					@Prop({ type: String, required: true, default: "" }) id!: string;
					@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.None }) objectType!: ObjectTypesHelper.ObjectTypeEnum;
					
					@Prop({ type: Boolean, required: false, default: false }) onlyOne?: boolean; //vyber pouze jednoho prvku

                    @Prop({ type: Boolean, required: false, default: false }) moreActionAllow1Objects?: boolean; //posilani celych objektu, misto IDcek, pro specialni pripady

                    @Prop({ type: String, required: false, default: "" }) moreActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka
                    @Prop({ type: String, required: false, default: "" }) moreActionIcon2?: string; //jaka ma byt pouzita ikona u tlacitka2
                    @Prop({ type: String, required: false, default: "" }) moreActionIcon3?: string; //jaka ma byt pouzita ikona u tlacitka3

                    @Prop({ type: String, required: false, default: "" }) moreActionIconVariant?: string; //jaka ma byt pouzita varianta green, red
                    @Prop({ type: String, required: false, default: "" }) moreActionIconVariant2?: string; //jaka ma byt pouzita varianta green, red
                    @Prop({ type: String, required: false, default: "" }) moreActionIconVariant3?: string; //jaka ma byt pouzita varianta green, red

                    @Prop({ type: String, required: false, default: "" }) moreActionTitle?: string; //nazev pro hromadnou akci
                    @Prop({ type: String, required: false, default: "" }) moreActionTitle2?: string; //nazev pro hromadnou akci 2
                    @Prop({ type: String, required: false, default: "" }) moreActionTitle3?: string; //nazev pro hromadnou akci 3

                    @Prop({ type: Boolean, required: false, default: true }) moreActionAllow1?: boolean; //enabale/disable hromadne akce
                    @Prop({ type: Boolean, required: false, default: true }) moreActionAllow2?: boolean; //enabale/disable hromadne akce
                    @Prop({ type: Boolean, required: false, default: true }) moreActionAllow3?: boolean; //enabale/disable hromadne akce

                    @Prop({ type: String, required: false, default: "" }) moreActionTooltip?: string; //napoveda k akci
                    @Prop({ type: String, required: false, default: "" }) moreActionTooltip2?: string; //napoveda k akci 2
                    @Prop({ type: String, required: false, default: "" }) moreActionTooltip3?: string; //napoveda k akci 3

                    //zobrazeni akcnich tlacitek
                    @Prop({ type: Boolean, required: false, default: false }) buttonOther?: boolean; //button action - vlastni tlacitko
                    @Prop({ type: String, required: false, default: "Tisk" }) buttonOtherName?: string; //vlastní pojmenování tlačítka
                    @Prop({ type: String, required: false, default: '' }) buttonOtherParam?: string; //button action - vlastni tlacitko - parametry ktery musi splnit aby bylo viditelne
                    @Prop({ type: String, required: false, default: "buttonAdd" }) buttonOtherClass?: string; //vlastní tlačítka css class

					selectedItems = [];
					idComponent = 0;

                    names = ['name'];

					showFilterSettings(): void {
						(this.$refs.tableModal as BaseTlTable).showFilterSettings();
					}

                    useSelected(selected: any): void {
						this.$emit('selected', selected);			                     
                        this.$bvModal.hide(this.id);
                    }

					close(): void {
						this.$bvModal.hide(this.id);
                    }

                    clickOther(item:any) {
                        this.$emit('clickOther', item);
                    }

                    doubleClick(item: any, index: any, selectedItems: any) {
                        if (this.allowDoubleClick) {
                            if (this.moreActionAllow1Objects) {
                                this.$emit('doubleClickRow', [item]);
                                this.$emit('selected', [item]);
                            }
                            else {
                                this.$emit('doubleClickRow', [item.id]);
                                this.$emit('selected', [item.id]);
                            }
                            this.$bvModal.hide(this.id);
                        }
                    }

                    isShowSetting = false;
                    changeShowFilterColumnSetting(show: boolean) {
                        this.isShowSetting = show;
                    }

	}

